// Temporary beta-stack access deterrent. This value is compiled into the SPA
// and is therefore not production authentication; the API refuses to enable
// the mechanism on the production national stack.
export const withBetaApiGate = (config = {}) => {
  const token = (process.env.REACT_APP_BETA_API_GATE_TOKEN || "").trim();
  if (!token) return config;
  return {
    ...config,
    headers: {
      ...(config.headers || {}),
      "X-PXN-Beta-Gate": token,
    },
  };
};
